var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.activeSubscription
    ? _c("div", { staticClass: "ui two column stackable grid" }, [
        _c(
          "div",
          {
            staticClass:
              "sixteen wide mobile six wide tablet four wide computer column"
          },
          [
            _c("div", { staticClass: "ui one cards" }, [
              _c("div", { staticClass: "card" }, [
                _c("div", { staticClass: "content" }, [
                  _c("div", { staticClass: "header" }, [
                    _vm._v(_vm._s(_vm.FullName))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "meta" }, [
                    _c("a", [_vm._v(_vm._s(_vm.addressLine))])
                  ]),
                  _vm._v(" "),
                  _vm.mandatoryFields.length > 0
                    ? _c(
                        "div",
                        { staticClass: "description" },
                        _vm._l(_vm.mandatoryFields, function(merchantField) {
                          return _c(
                            "div",
                            {
                              key: merchantField.id,
                              staticClass: "info-piece"
                            },
                            [
                              _c("div", { staticClass: "info-label" }, [
                                _vm._v(_vm._s(merchantField.name))
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "info-text" }, [
                                _vm._v(_vm._s(merchantField.meta.value))
                              ])
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "extra content" }, [
                  _c("span", [
                    _c("i", { staticClass: "payment icon" }),
                    _vm._v(
                      "\n\t\t\t\t\t\t\t" +
                        _vm._s(_vm.subscriptions.total) +
                        " " +
                        _vm._s(
                          _vm.$t("pages.dashboard.details.subscriptions")
                        ) +
                        "\n\t\t\t\t\t\t"
                    )
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _vm.$store.getters.activeMerchant.kamstrup &&
            _vm.activeSubscription.product.category.water_meter
              ? _c("div", { staticClass: "ui one cards" }, [
                  _c("div", { staticClass: "card" }, [
                    _vm.activeSubscription.kamstrup_user
                      ? _c("div", { staticClass: "content" }, [
                          _c(
                            "div",
                            {
                              staticClass: "header",
                              staticStyle: { color: "#f39c12" }
                            },
                            [_vm._v("Kamstrup")]
                          ),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "pages.dashboard.details.kamstrup.headers.meter_info"
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "description" }, [
                            _c("div", { staticClass: "info-piece" }, [
                              _c("div", { staticClass: "info-label" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "pages.dashboard.details.kamstrup.meter_serial_number"
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "info-text" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.activeSubscription.kamstrup_user
                                      .meter_number
                                  ) + "\n                "
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "info-piece" }, [
                              _c("div", { staticClass: "info-label" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "pages.dashboard.details.kamstrup.meter_type"
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "info-text" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.activeSubscription.kamstrup_user
                                      .meter_type
                                  ) + "\n                "
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "info-piece" }, [
                              _c("div", { staticClass: "info-label" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "pages.dashboard.details.kamstrup.consumption_type"
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "info-text" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.activeSubscription.kamstrup_user
                                      .consumption_type
                                  ) + "\n                "
                                )
                              ])
                            ])
                          ])
                        ])
                      : _vm._e()
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.$store.getters.activeMerchant.kamstrup &&
            _vm.activeSubscription.product.category.water_meter
              ? _c("div", { staticClass: "ui one cards" }, [
                  _c("div", { staticClass: "card" }, [
                    _vm.currentMeter
                      ? _c("div", { staticClass: "content" }, [
                          _c(
                            "div",
                            {
                              staticClass: "header",
                              staticStyle: { color: "#f39c12" }
                            },
                            [
                              _vm._v(
                                "Kamstrup - " +
                                  _vm._s(
                                    _vm.$t(
                                      "pages.dashboard.details.kamstrup.current_period"
                                    )
                                  )
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "pages.dashboard.details.kamstrup.headers.meter_data"
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "description" }, [
                            _c("div", { staticClass: "info-piece" }, [
                              _c("div", { staticClass: "info-label" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "pages.dashboard.details.kamstrup.from"
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "info-text" }, [
                                _vm._v(_vm._s(_vm.currentFrom))
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "info-piece" }, [
                              _c("div", { staticClass: "info-label" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "pages.dashboard.details.kamstrup.to"
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "info-text" }, [
                                _vm._v(_vm._s(_vm.currentTo))
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "info-piece" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "info-label",
                                  staticStyle: { color: "#00a9f7" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "pages.dashboard.details.kamstrup.total"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _vm.currentMeter.meter_reading_total !== null
                                ? _c("div", { staticClass: "info-text" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.currentMeter.meter_reading_total
                                        ) +
                                        " m"
                                    ),
                                    _c("sup", [_vm._v("3")])
                                  ])
                                : _c("div", [
                                    _vm._v(
                                      "\n                  -\n                "
                                    )
                                  ])
                            ])
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.previousMeter
                      ? _c("div", { staticClass: "content" }, [
                          _c(
                            "div",
                            {
                              staticClass: "header",
                              staticStyle: { color: "#7f8c8d" }
                            },
                            [
                              _vm._v(
                                "Kamstrup - " +
                                  _vm._s(
                                    _vm.$t(
                                      "pages.dashboard.details.kamstrup.previous_period"
                                    )
                                  )
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "description" }, [
                            _c("div", { staticClass: "info-piece" }, [
                              _c("div", { staticClass: "info-label" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "pages.dashboard.details.kamstrup.from"
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "info-text" }, [
                                _vm._v(_vm._s(_vm.previousFrom))
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "info-piece" }, [
                              _c("div", { staticClass: "info-label" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "pages.dashboard.details.kamstrup.to"
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "info-text" }, [
                                _vm._v(_vm._s(_vm.previousTo))
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "info-piece" }, [
                              _c("div", { staticClass: "info-label" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "pages.dashboard.details.kamstrup.total"
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "info-text" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.previousMeter.meter_reading_total
                                  ) + " m"
                                ),
                                _c("sup", [_vm._v("3")])
                              ])
                            ])
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.currentMeter
                      ? _c("div", { staticClass: "content" }, [
                          _c(
                            "div",
                            {
                              staticClass: "header",
                              staticStyle: { color: "#f39c12" }
                            },
                            [_vm._v("Kamstrup")]
                          ),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "pages.dashboard.details.kamstrup.headers.meter_data"
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "description" }, [
                            _c("div", { staticClass: "info-piece" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "info-label",
                                  staticStyle: { color: "#00a9f7" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "pages.dashboard.details.kamstrup.total"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "info-text" }, [
                                _vm._v("0")
                              ])
                            ])
                          ])
                        ])
                      : _vm._e()
                  ])
                ])
              : _vm._e()
          ]
        ),
        _vm._v(" "),
        _vm.editableFields.length > 0 || _vm.showMobilePayNotice
          ? _c(
              "div",
              {
                staticClass:
                  "sixteen wide mobile ten wide tablet twelve wide computer column"
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "ui padded segment",
                    class: { loading: _vm.showLoader }
                  },
                  [
                    _c("div", { staticClass: "ui horizontal divider header" }, [
                      _vm._v(_vm._s(_vm.activeSubscription.product.name))
                    ]),
                    _vm._v(" "),
                    _vm.showMobilePayNotice
                      ? [
                          _c("div", { staticClass: "ui divider" }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "ui horizontal red header",
                              staticStyle: { "text-align": "center" }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t(
                                      "pages.dashboard.details.mobile_pay_instant_notice"
                                    )
                                  ) +
                                  "\n          "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "ui divider" })
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "ui zw form error",
                        attrs: { "data-vv-scope": "editForm" }
                      },
                      [
                        _vm._l(
                          _vm.chunkProperty(_vm.editableFields, 2),
                          function(editableField, index) {
                            return _c(
                              "div",
                              { key: index, staticClass: "two fields" },
                              _vm._l(editableField, function(field) {
                                return field
                                  ? _c("field", {
                                      key: field.id,
                                      attrs: {
                                        field: field,
                                        allowEdit: _vm.allowEditing,
                                        isactive:
                                          _vm.activeSubscription.status ===
                                            "active" ||
                                          _vm.activeSubscription.status ===
                                            "delayed",
                                        scope: "editForm",
                                        value: _vm.fieldValues,
                                        transparent: !_vm.allowEditing
                                      },
                                      on: { input: _vm.changeFieldValue }
                                    })
                                  : _vm._e()
                              }),
                              1
                            )
                          }
                        ),
                        _vm._v(" "),
                        _vm.editableFields.length > 0 &&
                        _vm.isNotInactive &&
                        !_vm.allowEditing
                          ? _c(
                              "div",
                              {
                                staticClass: "ui blue button",
                                on: {
                                  click: function($event) {
                                    return _vm.showEditForm()
                                  }
                                }
                              },
                              [
                                _c("i", { staticClass: "edit icon" }),
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.$t("globals.buttons.edit")) +
                                    "\n          "
                                )
                              ]
                            )
                          : _vm.allowEditing
                          ? _c(
                              "button",
                              {
                                staticClass: "ui green button",
                                attrs: { type: "submit" },
                                on: {
                                  click: function($event) {
                                    return _vm.saveEditForm("editForm")
                                  }
                                }
                              },
                              [
                                _c("i", { staticClass: "checkmark icon" }),
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.$t("globals.buttons.save")) +
                                    "\n          "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.allowEditing
                          ? _c(
                              "div",
                              {
                                staticClass: "ui red button",
                                on: {
                                  click: function($event) {
                                    return _vm.cancelEditForm("editForm")
                                  }
                                }
                              },
                              [
                                _c("i", { staticClass: "cancel icon" }),
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.$t("globals.buttons.cancel")) +
                                    "\n          "
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      2
                    )
                  ],
                  2
                )
              ]
            )
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6beb5bdf", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6beb5bdf","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/dashboard/SubscriptionDetails.vue
// module id = Nskv
// module chunks = 1